import { Omit } from '@app/utils/omit';

export interface ClaimModel {
    id: number;
    memberName: string;
    allowanceDescription: string;
    expenditureDescription: string;
    claimDate: Date;
	amount: number;
}

export interface ClaimModelAjax extends Omit<ClaimModel, 'claimDate'> {
    claimDate: string;
}

export class ClaimModelFactory {
    static build(props?: ClaimModel | ClaimModelAjax) {
        if (!props) {
            return null;
        }

        const model = Object.assign({}, props) as ClaimModel | ClaimModelAjax;

        if (typeof model.claimDate === "string") {
            model.claimDate = new Date(model.claimDate);
        }

        return model as ClaimModel;
    }
}
